import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BackendAccessService } from '../../../Services/APICalls/backend-access-service';
import { MatDialog } from '@angular/material/dialog';
import { SatAdminDeleteDialogComponent } from '../sat-admin-delete-dialog/sat-admin-delete-dialog.component';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sat-admin-landing-page',
  templateUrl: './sat-admin-landing-page.component.html',
  styleUrls: ['./sat-admin-landing-page.component.scss'],
  standalone: false,
})
export class SatAdminLandingPageComponent implements AfterViewInit {
  displayedColumns: string[] = [
    'dateCreated',
    'subscriptionIdentifier',
    'productName',
    'configuredComps',
    'purchaserEmail',
    'actions',
  ];
  dataSource = new MatTableDataSource<{ recordId: string }>();
  selectedTabIndex = 0;

  @ViewChild('pendingPaginator') paginator!: MatPaginator;
  @ViewChild('pendingSort') sort!: MatSort;

  constructor(
    readonly backend: BackendAccessService,
    public dialog: MatDialog,
    readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  /* istanbul ignore next */
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['tab']) {
        this.selectedTabIndex = +params['tab'];
      }
      this.loadPendingSubs();
    });
  }

  /* istanbul ignore next */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /* istanbul ignore next */
  onTabChange(index: number) {
    this.selectedTabIndex = index;
  }

  /* istanbul ignore next */
  loadPendingSubs() {
    this.backend.getPendingSubConfigurations().subscribe({
      next: (data) => {
        this.dataSource.data = data.map((item: any) => ({
          ...item,
          dateCreated: item.createdDate,
          productName: item.subscriptionData?.product_name,
          configuredComps:
            item.subscriptionData?.components
              ?.map((component: any) => component.name)
              .join(', ') || '',
        }));
      },
      error: (error) => {
        console.error('Error fetching pending subscriptions:', error);
      },
    });
  }

  /* istanbul ignore next */
  openDeleteDialog(recordId: string, subscriptionIdentifier: string) {
    const dialogRef = this.dialog.open(SatAdminDeleteDialogComponent, {
      width: '500px',
      data: { subscriptionIdentifier },
    });
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.backend.deleteSubConfigurations(recordId).subscribe({
          next: () => {
            this.dataSource.data = this.dataSource.data.filter(
              (item: { recordId: string }) => item.recordId !== recordId
            );
          },
          error: (error) => {
            console.error('Error deleting subscription:', error);
          },
        });
      }
    });
  }

  /* istanbul ignore next */
  navigateToCreate() {
    this.router.navigate(['/sat-subscriptions-config']);
  }

  /* istanbul ignore next */
  navigateToEdit(recordId: string) {
    this.router.navigate(['/sat-subscriptions-config', recordId]);
  }
}
